<template>

  <div>

    <div class="ui large breadcrumb">
      <div class="section">
        <strong>Orçamentos</strong>
      </div>
    </div>

    <div class="ui divider"></div>

    <button class="ui blue icon button m-b-15" @click="onNewQuotation()">
      <i class="plus icon"></i>
      Novo Orçamento
    </button>

    <quotations-filter ref="filter" :active="filterActive" :searching="loading" @onSearch="onSearch"/>

    <div v-if="loading" class="m-t-20"><i class="spinner circle loading blue icon"></i> Carregando ...</div>

    <div class="two wide field">
      <div v-if="!loading && infoLabel" class="ui small label m-t-15">
        <i class="info circle icon"></i>{{ infoLabel }}
      </div>
      <div v-if="$store.state.quotations && $store.state.quotations.length > 0 && canSeeRg()" class="ui toggle checkbox m-t-15">
        <input v-model="impostos" type="checkbox" name="impostos">
        <label>impostos</label>
      </div>
    </div>
    
    <div v-if="$store.state.quotations && $store.state.quotations.length > 0" class="animated fadeIn" style="margin-top: 15px;">

      <div class="ui segment" style="padding: 20px !important;">
        <table class="ui very basic celled selectable tablet sortable stackable table">
          <thead class="desktop-only">
            <tr>
              <th>Status</th>
              <th>Número</th>
              <th>Data</th>
              <th>Hora</th>
              <th>Cliente</th>
              <th>Representante</th>
              <th>Total Sugerido</th>
              <th>Total Aprovado</th>
              <th>Pedido</th>
              <th>NF</th>
              <th>Regras</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="quotation in $store.state.quotations" class="clickable" @click="showQuotation(quotation.id)">
              <td style="white-space: nowrap;">
                <i class="icon" :class="quotation.statusData.icon + ' ' + quotation.statusData.color"></i> 
                {{ quotation.statusData.description }}
              </td>
              <td><strong class="mobile-only">Número: </strong>{{ quotation.id }}</td>
              <td><strong class="mobile-only">Data: </strong>{{ $formatDate(quotation.date) }}</td>
              <td><strong class="mobile-only">Hora: </strong>{{ quotation.time }}</td>
              <td><strong class="mobile-only">Cliente: </strong>{{ quotation.nameCustomer }}</td>
              <td><strong class="mobile-only">Representante: </strong>{{ quotation.nameUser }}</td>
              <td><strong class="mobile-only">Total Sugerido: </strong>R$ {{ $formatCurrency(quotation.sugTotal) }}</td>
              <td><strong class="mobile-only">Total Aprovado: </strong>R$ {{ $formatCurrency(quotation.appTotal) }}</td>
              <td style="white-space: nowrap;">
                <strong class="mobile-only">Pedido: </strong>
                <div v-if="quotation.lastOrder" class="ui label">
                  {{ quotation.lastOrder }}
                  <div v-if="quotation.ordersCount > 1" class="detail">
                    +{{ quotation.ordersCount - 1 }}
                  </div>
                </div>                  
              </td>
              <td>
                <strong class="mobile-only">Nota Fiscal: </strong>
                <div v-if="quotation.lastInvoice" class="ui label">
                  {{ quotation.lastInvoice }}
                  <div v-if="quotation.invoicesCount > 1" class="detail">
                    +{{ quotation.invoicesCount - 1 }}
                  </div>
                </div>
              </td>
              <td>
                <strong class="mobile-only">Regras: </strong>
                <RulesShow :Rules=quotation.rules />
              </td>
            </tr>                       
          </tbody>
        </table>
      </div>

    </div>

  </div>

</template>

<script>

  import QuotationsFilter from "./filter.vue"
  import QuotationService from "@/services/quotation-service"
  import RulesShow from "@/components/rules-show.vue"

  const MAX_SEARCH_RECORDS = 300

  export default {

    data() {
      return {
        loading: false,
        filterActive: true,
        impostos: false,
      }
    },

    computed: {

      infoLabel() {

        if (!this.$store.state.quotations)
          return "Preencha os filtros e clique em Pesquisar"

        let label = ""
        let count = this.$store.state.quotations.length

        if (count == 0) {

          label = "Nenhum registro encontrado"

        } else if (count == 1) {

          label = "1 registro encontrado"

        } else if (count == MAX_SEARCH_RECORDS) {

          label = "Sua pesquisa retornou o limite de registros suportados. Tente refinar os critérios de filtro."  

        } else {

          label = count + " registros encontrados"
        }

        return label
      },
    },

    components: {
      QuotationsFilter,
      RulesShow
    },    

    created() {
      if (this.$store.state.quotations && this.$store.state.quotations.length > 0)
        this.filterActive = false
    },

    methods: {
      canSeeRg() {
        return QuotationService.canSeeRg()
      },
      onNewQuotation() {
        this.$router.push("/quotations/form/new")
      },

      async onSearch(filter) {

        if (this.loading)
          return

        this.loading = true

        try {

          const quotations = await QuotationService.search(filter)
          this.$store.commit("setQuotations", quotations)

          this.loading = false

          if (quotations.length > 0) {
            this.$refs.filter.toggleActive()            
            this.$scroll.toTop()
          }  

        } catch (error) {

          this.loading = false

          this.$errorHandler(error)
        }
      },

      showQuotation(id) {
        this.$router.push(`/quotations/show/${id}?impostos=${this.impostos}`)
      },
    },
  }

</script>
